import React from "react";
import ThemedButton from "../ui/ThemeButton";
interface NavbarProps {
  hero: any;
  activeLink?: string;
  themeColor: string;
}

const MicrositeNavbar: React.FC<NavbarProps> = ({ hero, activeLink, themeColor="#885ABB" }) => {
  const logo = hero.logo || "/logo.svg";
  const title = hero.title || "Glossa Hair Studio";
  const cta = hero.cta || "Book an Appointment";

  return (
    <header className="fixed w-full top-0 left-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200 font-serif">
      <div className="container mx-auto flex justify-between items-center px-6 md:px-16 py-4">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <img src={logo} alt="Logo" className="h-14 w-14" />
        </div>

        {/* Nav Links */}
        <nav className="space-x-8 hidden md:flex">
          {["home", "about", "services", "testimonial", "contact"].map(
            (section) => (
              <a
                key={section}
                href={`#${section}`}
                className={`relative font-medium capitalize transition-all after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:rounded-full after:transition-all after:duration-300 ${
                  activeLink === section
                    ? "after:w-full"
                    : "after:w-0 hover:after:w-full"
                }`}
                style={{
                  color: activeLink === section ? themeColor : "#4B5563",
                }}
              >
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </a>
            )
          )}
        </nav>

        {/* CTA Button */}
        <ThemedButton
  themeColor={themeColor}
  onClick={() => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      const offset = 80; 
      const position = contactSection.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: position, behavior: "smooth" });
    }
  }}
>
  {hero.ctaText}
</ThemedButton>
      </div>

      {/* Theme color applied globally for hover and underline */}
      <style>{`
        nav a::after {
          background-color: ${themeColor};
        }
        nav a:hover {
          color: ${themeColor};
        }
      `}</style>
    </header>
  );
};

export default MicrositeNavbar;
